import { NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';

export class DDDateAdapter extends NgxMatNativeDateAdapter {
    getFirstDayOfWeek(): number {
        return 1;
    }
}